var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Output',{attrs:{"kokubanDataList":_vm.kokubanDataList,"currentConstruction":_vm.currentConstruction},on:{"reloadKokubanDataList":function($event){return _vm.reloadKokubanDataList($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }